import { Page, User } from "referral-types";

export function getUserDashboardUrl(userId: string) {
    return `/user/${userId}`;
}

export function getUserHomePageUrl(user: User) {
    return user.homePageName != null ? `/${user.homePageName}` : `/page/${user.homePageId}`;
}

export function getPageUrl(page: Page, options: { slug?: string, includeHost?: boolean } = {}) {
    const { slug, includeHost } = options;
    const baseUrl = includeHost ? `${window.location.origin}` : '';
    return page.pageName != null ? `${baseUrl}/${page.pageName}${slug ? `/${slug}` : ''}` : `${baseUrl}/page/${page.id}${slug ? `/${slug}` : ''}`;
}
